var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trend",attrs:{"id":"trend"}})
}
var staticRenderFns = []

export { render, staticRenderFns }